import { render, staticRenderFns } from "./EvenListChatMessage.vue?vue&type=template&id=1d71b6f9&scoped=true&"
import script from "./EvenListChatMessage.vue?vue&type=script&lang=js&"
export * from "./EvenListChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./EvenListChatMessage.vue?vue&type=style&index=0&id=1d71b6f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d71b6f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VChip,VCol,VIcon})
